import { ShipmentSapDeliveryListSearchCriteria } from '../../../../../common/models';

export class ShipmentTransportOrderSapDeliveriesLoad {
  public static readonly type = '[ShipmentTransportOrderSapDeliveries] Load';
  constructor(public payload: ShipmentSapDeliveryListSearchCriteria) {}
}

export class ShipmentTransportOrderSapDeliveriesInitialState {
  public static readonly type = '[ShipmentTransportOrderSapDeliveries] Set Initial State';
}
